import React from "react";

export function File({ name }: { name: string }): React.ReactElement {
  return <em>{name}</em>;
}
